// Capture an Open Banking redirect that lands on the app itself.
//
// Enable Banking redirects the user back to `${APP_BASE_URL}/settings?code=…&state=…`
// (not always to our server callback). The Supabase client uses flowType "pkce"
// with detectSessionInUrl on, so at startup it grabs ANY `?code=` in the URL and
// tries to exchange it as a login — which fails for a bank code AND consumes it,
// leaving the link stuck. So we must lift the bank callback out of the URL before
// the Supabase client initialises.
//
// This lives in the app bundle and is imported FIRST in main.ts, so:
//  - it runs before the Supabase module evaluates (which is what the old inline
//    index.html guard tried to do, but that guard was silently blocked by the
//    CSP `script-src 'self'` — a bundle module is 'self', so it's allowed), and
//  - App.vue then finalizes from sessionStorage once authenticated.
//
// We only treat /settings code+state as a bank callback; Supabase OAuth login
// redirects to the site root ("/"), so login is unaffected.
try {
  const params = new URLSearchParams(window.location.search)
  const code = params.get("code")
  const state = params.get("state")
  const path = window.location.pathname.replace(/\/+$/, "")
  if (code && state && path === "/settings") {
    sessionStorage.setItem("bank_callback", JSON.stringify({ code, state }))
    params.delete("code")
    params.delete("state")
    const qs = params.toString()
    window.history.replaceState({}, "", window.location.pathname + (qs ? `?${qs}` : ""))
  }
} catch {
  /* best effort — fall through to the app */
}
